import * as React from "react"
import Overlay from "./sections/com_overlay"
import bruneauFrontImg from "../../core/assets/bruneau_front.jpg"

export interface IErrorBoundaryState {
  hasError: boolean
}
export interface IErrorBoundaryProps {
  children?: React.ReactNode
}

class ErrorBoundary extends React.Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  public componentDidCatch(error: any, info: any) {
    this.setState({ hasError: true })
    console.log(error, info)
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            margin: "auto",
          }}
        >
          <Overlay />
          <h1
            style={{
              margin: "auto",
            }}
          >
            Something went wrong.
          </h1>
          <img
            alt="bruneaufront"
            style={{
              margin: "auto",
              width: "auto",
              height: "60%",
              borderRadius: "35px",
            }}
            src={bruneauFrontImg}
          />
          <h2
            style={{
              margin: "auto",
            }}
          >
            Please refresh the page. If the problem persists please contact a
            member of staff.
          </h2>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
